/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from "react";
import { Button, Tooltip, Card } from "@material-tailwind/react";
import DataTable from "../../components/DataTable";
import { Loader2, Upload, Eye, Settings, CalendarCheck2, LucideCalendarCog, Info, CalendarPlus, HousePlus, UserRoundPlus, Users } from "lucide-react";
import ScheduleVisit from "../../components/ScheduleVisit";
import RescheduleVisit from "../../components/RescheduleVisit";
import {
    scheduleVisit,
    updateVisit,
} from "../../services/users";
import { fetchProjects } from "../../services/projects"; // Import fetchProjects
import { toast } from "react-toastify";
import { useUser } from "../../context/UserContext";
import usePermission from "../../hooks/usePermission";
import { PERMISSIONS } from "../../constants/permissions";
import useSubscriptionFeatures from "../../hooks/useSubscriptionFeatures";
import { SUB_FEATURES } from "../../constants/subscriptionFeatures";
import DisabledWithTooltip from "../../components/DisabledWithTooltip";
import CustomInput from "../../components/CustomInput";
import {
    CloseButton,
    EditButton,
    IconButton,
    PrimaryButton,
} from "../../components/Buttons";

import axiosInstance from "../../services/api/axios";
import EditUserModal from "../../components/EditForms/EditUserModal";
import LeadStatusRenderer from "../../components/cellRenderers/LeadStatusRenderer";
import ReferralTagRenderer from "../../components/cellRenderers/ReferralTagRenderer";

import CreateUser from "./CreateUser";
import LeadDetailsDrawer from "./LeadDetailsDrawer";
import ManualLeadUploadModal from "./ManualLeadUploadModal";
import ConfigAssignmentModal from "../../components/ConfigAssignmentModal";
import CsvUploadModal from "./CsvUploadModal";
import PreAccountEditModal from "./PreAccountEditModal";

function VisitStatusCellRenderer(props) {
    const [rowIsLoading, setRowIsLoading] = useState(false);
    const { data, visitData, handleMarkAsVisited, globalLoading } = props;

    const handleRowMarkAsVisited = async () => {
        setRowIsLoading(true);
        try {
            await props.handleMarkAsVisited(data, visitData); // Pass both data and visitData
        } finally {
            setRowIsLoading(false);
        }
    };

    // Show loading if either local row loading or global loading is active
    const isLoading = rowIsLoading || globalLoading;

    return (
        <div className="flex items-center space-x-2 h-full">
            {visitData?.visited === true ? (
                // Display content when visited is TRUE
                <div className="w-fit px-2 py-1 rounded-md text-sm font-medium bg-emerald-500/30 text-emerald-700 hover:bg-emerald-500/40 flex items-center justify-center">
                    Visited
                </div>
            ) : (
                // Display content when visited is FALSE (or null/undefined)
                <>
                    <Tooltip placement="right">
                        <Tooltip.Trigger>
                            {isLoading ? (
                                <div className="flex items-center justify-center p-2">
                                    <Loader2 className="size-4 animate-spin" />
                                </div>
                            ) : (
                                <Button
                                    size="sm"
                                    variant="outline"
                                    color="green"
                                    onClick={handleRowMarkAsVisited}
                                    disabled={isLoading}
                                    className="p-2 bg-white text-green-600"
                                >
                                    <CalendarCheck2 size={17.5} />
                                </Button>
                            )}
                        </Tooltip.Trigger>
                        <Tooltip.Content className="bg-slate-800 text-white font-normal text-sm">
                            Mark as visited
                            <Tooltip.Arrow />
                        </Tooltip.Content>
                    </Tooltip>
                </>
            )}
        </div>
    );
}


function LeadsDashboard() {
    const { userInfo } = useUser();
    const { can, isDeveloperAdmin, isChannelPartner } = usePermission();
    const [activeTab, setActiveTab] = useState(() => {
        // Set default tab based on user role
        if (!isDeveloperAdmin() && can(PERMISSIONS.SALE_READ) && !can(PERMISSIONS.LEAD_DELETE)) {
            return "hot";
        }
        return "cold";
    });
    const [searchQuery, setSearchQuery] = useState("");
    const [users, setUsers] = useState(null);
    const [allLeads, setAllLeads] = useState({});  // store all the leeds from the api at onec 
    const [filteredUsers, setFilteredUsers] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [scheduledVisitsCount, setScheduledVisitsCount] = useState(0);
    const user = useUser();
    const [createCustomerModalOpen, setCreateCustomerModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [uploadLeadsDropdownOpen, setUploadLeadsDropdownOpen] = useState(false);
    const [manualUploadModalOpen, setManualUploadModalOpen] = useState(false);
    const gridApi = useRef(null);
    const [refreshLeads, setRefreshLeads] = useState(false);
    const [newScheduleVisit, setNewScheduleVisit] = useState({
        firstName: "",
        lastName: "",
        mobileNoWa: "",
        mobileNoCalling: "",
        emailId: "",
        preferredDate: "",
        preferredTime: "",
        propertyConfig: "",
        buildingId: "",
    });
    const [selectedProject, setSelectedProject] = useState(null);  //Add this state
    const [isPreAccountEditModalOpen, setIsPreAccountEditModalOpen] = useState(false); 
    const [editedPreAccountUser, setEditedPreAccountUser] = React.useState(null)

    // eslint-disable-next-line no-unused-vars
    const [selectedPropertyConfig, setSelectedPropertyConfig] = useState(null);
    const [assignConfigModalOpen, setAssignConfigModalOpen] = useState(false);
    const [propertyConfigs, setPropertyConfigs] = useState([]);
    const [configAssignmentLoading, setConfigAssignmentLoading] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [selectedUploadOption, setSelectedUploadOption] = useState("");
    const [csvUploadModalOpen, setCsvUploadModalOpen] = useState(false);
    const [selectedCsvFile, setSelectedCsvFile] = useState(null);
    const [projects, setProjects] = useState([]);  // State to store projects
    const [isCreatingUser, setIsCreatingUser] = useState(false);
    const [scheduleVisitModalOpen, setScheduleVisitModalOpen] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const role = user?.userInfo?.persona || "Guest";
    const [isLoading, setIsLoading] = useState(false);
    const [leadDetailsDrawerOpen, setLeadDetailsDrawerOpen] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    // eslint-disable-next-line no-unused-vars
    const [openCreateUserDialog, setOpenCreateUserDialog] = useState(false);
    const [createUser, setCreateUser] = useState({
        firstName: "",
        lastName: "",
        mobileNoWa: "",
        mobileNoCalling: "",
        emailId: "",
        address: {
            buildingNo: "",
            streetName1: "",
            streetName2: "",
            city: "",
            district: "",
            pinCode: "",
            state: "",
            country: "",
        },
        gender: "MALE",
        title: "MR",
        dob: new Date().toISOString().split("T")[0],
        isSecondaryUser: true,
        occupation: "",
    });

    const occupations = [
        "Engineering",
        "Agriculture",
        "Healthcare",
        "Education",
        "Business",
        "Finance",
        "Technology",
        "Arts",
        "Other",
    ];
    const [visibleColumns, setVisibleColumns] = useState({});
    const [columnVisibilityOpen, setColumnVisibilityOpen] = useState(false);

    // Components for AG Grid
    const components = {
        leadStatusRenderer: LeadStatusRenderer
    };

    const fetchCustomerUsers = useCallback(async () => {
        try {
            setUsers(null);

            let params;
            if (isChannelPartner()) {
                params = {
                    agentId: userInfo.loginIdentifierDetails.customerId
                };
            } else {
                params = {
                    customerId:
                        userInfo.loginIdentifierDetails.customer?.customerId ??
                        userInfo.loginIdentifierDetails.customerId,
                };
            }

            const response = await axiosInstance.get(`/users/leads-bifurcation`, {
                params,
            });

            // Handle paginated response format
            const responseData = response?.data || response;
            
            setUsers(responseData);

            // Helper function to safely get array from response
            const getArray = (data, key) => {
                const value = data?.[key];
                if (Array.isArray(value)) {
                    return value;
                }
                // Handle paginated response
                if (value?.items && Array.isArray(value.items)) {
                    return value.items;
                }
                return [];
            };

            // Set each lead type individually
            const processedLeads = {
                coldLeads: getArray(responseData, 'coldLeads').map(lead => ({ ...lead, leadType: 'cold' })),
                lukeWarmLeads: getArray(responseData, 'lukeWarmLeads').map(lead => ({ ...lead, leadType: 'lukeWarm' })),
                warmLeads: getArray(responseData, 'warmLeads').map(lead => ({ ...lead, leadType: 'warm' })),
                hotLeads: getArray(responseData, 'hotLeads').map(lead => ({ ...lead, leadType: 'hot' })),
                customers: getArray(responseData, 'customers').map(lead => ({ ...lead, leadType: 'customer' }))
            };
            setAllLeads(processedLeads);
            
            // Combine leads for filtering (can be optimized, see note below)
            const combinedLeads = [
                ...getArray(responseData, 'coldLeads'),
                ...getArray(responseData, 'lukeWarmLeads'),
                ...getArray(responseData, 'warmLeads'),
                ...getArray(responseData, 'hotLeads'),
                ...getArray(responseData, 'customers')
            ];
            // Use processedLeads to ensure correct structure
            const filtered = processFilteredUsers(processedLeads, activeTab);
            setFilteredUsers(Array.isArray(filtered) ? filtered : []);
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    }, [user, refreshLeads, isChannelPartner, can, isDeveloperAdmin]);

    // Function to update only a specific row instead of refetching entire table
    const handleRowUpdate = useCallback((updatedData, newLeadStatus) => {
        console.log('Updating row with new lead status:', newLeadStatus);
        
        // Update the specific row in filteredUsers
        setFilteredUsers(prevFilteredUsers => {
            if (!Array.isArray(prevFilteredUsers)) {
                return [];
            }
            return prevFilteredUsers.map(user => {
                if (user.user_account?.user?.userId === updatedData.user_account?.user?.userId) {
                    return {
                        ...user,
                        user_account: {
                            ...user.user_account,
                            leadStatus: newLeadStatus
                        }
                    };
                }
                return user;
            });
        });

        // Also update in allLeads to keep data consistent
        setAllLeads(prevAllLeads => {
            const updatedLeads = { ...prevAllLeads };
            
            // Update in each lead type array
            Object.keys(updatedLeads).forEach(leadType => {
                if (updatedLeads[leadType]) {
                    updatedLeads[leadType] = updatedLeads[leadType].map(lead => {
                        if (lead.user_account?.user?.userId === updatedData.user_account?.user?.userId) {
                            return {
                                ...lead,
                                user_account: {
                                    ...lead.user_account,
                                    leadStatus: newLeadStatus
                                }
                            };
                        }
                        return lead;
                    });
                }
            });
            
            return updatedLeads;
        });
    }, []);

    const [scheduledVisits, setScheduledVisits] = useState([]);
    const [userVisitDateTime, setUserVisitDateTime] = useState({});


    const [openRescheduleDialog, setOpenRescheduleDialog] = useState(false);
    const [selectedVisit, setSelectedVisit] = useState(null);
    const [configurations, setConfigurations] = useState([]);
    const fetchScheduledVisitsCount = useCallback(async () => {
        try {
            let params = {
                customerId:
                    user.userInfo.loginIdentifierDetails.customer?.customerId,
            };

            if (isChannelPartner()) {
                params.agentId = user.userInfo.loginIdentifierDetails.customerId;
                delete params.customerId;
            }

            // Fetch all pages of visits to ensure complete data for table display
            let allVisits = [];
            let currentPage = 1;
            let hasMore = true;
            const pageSize = 50;

            while (hasMore) {
                const response = await axiosInstance.get(`/users/property`, {
                    params: {
                        ...params,
                        page: currentPage,
                        page_size: pageSize,
                    },
                });

                // Handle paginated response format: { items: [...], total: 1, page: 1, ... }
                let visitsArray = [];
                if (response?.data?.items && Array.isArray(response.data.items)) {
                    visitsArray = response.data.items;
                    const paginationInfo = response.data;
                    hasMore = paginationInfo.has_next || false;
                    currentPage += 1;
                } else if (response?.items && Array.isArray(response.items)) {
                    visitsArray = response.items;
                    hasMore = response.has_next || false;
                    currentPage += 1;
                } else if (Array.isArray(response?.data)) {
                    visitsArray = response.data;
                    hasMore = false; // If it's a direct array, no pagination
                } else if (Array.isArray(response)) {
                    visitsArray = response;
                    hasMore = false; // If it's a direct array, no pagination
                } else {
                    hasMore = false;
                }

                allVisits = [...allVisits, ...visitsArray];

                // Safety check: if we got fewer items than pageSize, we're done
                if (visitsArray.length < pageSize) {
                    hasMore = false;
                }
            }

            const filteredScheduledVisits = allVisits.filter(
                (visit) => visit.visitProgress === "visit_scheduled"
            );

            const visitDateTimeMap = {}; // Map to store visit date, visited status, and visitedDateTime
            allVisits.forEach(visit => {
                if (visit.user?.userId) {
                    visitDateTimeMap[visit.user.userId] = {
                        visitSchedule: visit.visitSchedule,
                        visited: visit.visited,
                        visitedDateTime: visit.visitedDateTime,
                        visitedCount: visit.visitedCount,
                        agentId: visit.agent?.customerId || visit.agentId,
                    };
                }
            });

            setUserVisitDateTime(visitDateTimeMap);

            setScheduledVisits(filteredScheduledVisits);
            setScheduledVisitsCount(filteredScheduledVisits.length);
        } catch (error) {
            console.error("Error fetching scheduled visits count:", error);
            setScheduledVisitsCount(0);
        }
    }, [user, isChannelPartner]);

    const handlePreAccountEditClick = (user) => {
        
        setEditedPreAccountUser(user);

        setIsPreAccountEditModalOpen(true);
    };
  // Function to handle saving details in the pre-account modal
    const handlePreAccountEditSave = async (updatedUser) => {
    try {
        const { userId, ...rest } = updatedUser;
        const payload = { ...rest }; 

  

        await axiosInstance.put(`/users`, payload, {
            params: { userId }
        });

        toast.success("Lead details updated successfully");
        fetchCustomerUsers();
        setIsPreAccountEditModalOpen(false);
    } catch (error) {
        console.error("Error updating lead details:", error);
        toast.error("Failed to update lead details");
    }
};


    useEffect(() => {
        const fetchAllProjects = async () => {
            try {
                const customerId = user.userInfo.loginIdentifierDetails.customer?.customerId ?? 
                                  user.userInfo.loginIdentifierDetails.customerId;
                
                // For agents, we need to get the primary customer ID from the relation
                if (isChannelPartner()) {
                    const relationResponse = await axiosInstance.get("/customers/relation", {
                        params: {
                            secondaryCustomerId: customerId,
                        },
                    });
                
                    // Handle both paginated and non-paginated responses
                    const relationArray = relationResponse?.items || (Array.isArray(relationResponse) ? relationResponse : []);
                    const projects = relationArray.map(relation => relation.project);
                    setProjects(projects);
                } else {
                    // For non-agents, use the regular project fetch
                    const response = await fetchProjects({ customerId });
                    setProjects(response);
                }
            } catch (error) {
                console.error("Error fetching projects:", error);
                toast.error("Failed to load projects.");
            }
        };
        const fetchAllConfigs = async () => {
            try {
                let projectId = null;
                let customerId = null;

                if (selectedProjectId) {
                    projectId = selectedProjectId;
                }
                // Get customerId from user context
                customerId = user.userInfo.loginIdentifierDetails.customer?.customerId ?? user.userInfo.loginIdentifierDetails.customerId;

                const params = {};
                if (projectId) {
                    params.projectId = projectId;
                }
                if (customerId) {
                    params.customerId = customerId;
                }

                // Use the new endpoint and send both params here
                const response = await axiosInstance.get("/property/config", {
                    params: {
                        ...params,
                        projectId: selectedProjectId,
                        customerId: user.userInfo.loginIdentifierDetails.customer?.customerId ?? user.userInfo.loginIdentifierDetails.customerId,
                    },
                });
                setPropertyConfigs(response);
            } catch (error) {
                console.error("Error fetching all configs:", error);
                toast.error("Failed to load property configurations.");
            }
        }

        fetchCustomerUsers();
        fetchScheduledVisitsCount();
        fetchAllProjects();
        fetchAllConfigs()
        

    }, [fetchCustomerUsers, fetchScheduledVisitsCount, user, selectedProjectId, isChannelPartner]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        const baseFiltered = processFilteredUsers(allLeads, activeTab);
        const filtered = (Array.isArray(baseFiltered) ? baseFiltered : []).filter((user) => {
            const query = e.target.value.toLowerCase();

            return Object.values(user).some((value) =>
                String(value).toLowerCase().includes(query)
            );
        });
        setFilteredUsers(Array.isArray(filtered) ? filtered : []);
    };

    const handleEditClick = (user) => {
        setSelectedUser(user);

        setEditModalOpen(true);
    };

    const handleEditCustomer = async (updatedUser) => {
        try {
            const payload = { ...updatedUser, address: { ...updatedUser.address } };
            await axiosInstance.put(`/users?userId=${updatedUser.userId}`, payload);
            toast.success("User details updated successfully");
            const updatedUsers = users.map((user) =>
                user.userId === updatedUser.userId ? { ...user, ...updatedUser } : user
            );
            setUsers(updatedUsers);
            setFilteredUsers(updatedUsers);
            setEditModalOpen(false);
            setSelectedUser(null);
        } catch (error) {
            console.error("Error updating user details:", error);
        }
    };
    const handleDelete = async (params) => {
        try {
            await axiosInstance.delete(`/customers/user/${params.userId}`);
            toast.success("User deleted successfully");
            const updatedUsers = users.filter(
                (user) => user.userId !== params.userId
            );
            setUsers(updatedUsers);
            setFilteredUsers(updatedUsers);
        } catch (error) {
            console.error("Error deleting user:", error);
        }
    };

    const handleCloseCreateModal = () => {
        setCreateCustomerModalOpen(false);
    };

    const handleCloseEditModal = () => {
        setEditModalOpen(false);
        setSelectedUser(null);
    };

    const handleScheduleVisitClick = (user) => {
        setSelectedUser(user);
        //console.log("selected user", user);
        setScheduleVisitModalOpen(true);
    };
    const handleAssignConfigClick = (user) => {
        setSelectedUser(user);
        setAssignConfigModalOpen(true);
    }

    const handleAssignConfig = async (selectedPropertyConfig) => {
        //console.log(selectedPropertyConfig);
        if (!selectedPropertyConfig) {
            toast.error("Please select a property configuration.");
            return;
        }

        try {
            setConfigAssignmentLoading(true);
            const payload = {
                customerId: user.userInfo.loginIdentifierDetails.customer.customerId,
                userId: selectedUser.user_account.user.userId,
                personaId: 2,
                projectId: selectedUser.user_account.project.projectId,
                comment: selectedUser.user_account.comment,
                status: selectedUser.user_account.status,
                propertyConfigId: Number(selectedPropertyConfig),
                lastMessageSentTimestamp: selectedUser.user_account.lastMessageSentTimestamp,
                lastReplyTimestamp: selectedUser.user_account.lastReplyTimestamp
            };
            const response = await axiosInstance.put(`/customers/user`, payload);
            toast.success("Property configuration assigned successfully!");
            setAssignConfigModalOpen(false);
            fetchCustomerUsers(); // Refresh table
            setSelectedPropertyConfig(null);

        } catch (error) {
            console.error("Error assigning property configuration:", error);
            toast.error("Failed to assign property configuration.");
        } finally {
            setConfigAssignmentLoading(false);
        }
    };
    const handleManualUploadModal = () => {
        setSelectedProject(null);
        setManualUploadModalOpen(true);
    };

    const handleLeadDetailsDrawerClose = () => {
        setLeadDetailsDrawerOpen(false);
        setRefreshLeads((prev) => !prev); // Toggle refreshLeads
    };
    const handleCsvUploadModalOpen = () => {
        setCsvUploadModalOpen(true);
    };

    const handleCsvUploadModalClose = () => {
        setCsvUploadModalOpen(false);
        setSelectedCsvFile(null);
    };

    const handleFileSelect = (event) => {
        setSelectedCsvFile(event.target.files[0]);
    };

    const handleCsvUpload = async (selectedProjectId) => {
        if (!selectedCsvFile) {
            toast.error("Please select a CSV file to upload.");
            return;
        }

        try {
            const formData = new FormData();
            formData.append('file', selectedCsvFile);

            const customerId = user.userInfo.loginIdentifierDetails.customer?.customerId ?? user.userInfo.loginIdentifierDetails.customerId;

            const response = await axiosInstance.post(`/users/leads/upload-csv?customerId=${customerId}&projectId=${selectedProjectId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });


            fetchCustomerUsers()
            handleCsvUploadModalClose();


        } catch (error) {
            console.error("Error uploading CSV:", error);
            toast.error("Failed to upload CSV.");
        }
    };
    const handleMarkAsVisited = async (visitData, currentVisit) => {
        setIsLoading(true);

        try {
            if (visitData) {
                const updatedVisitData = {
                    userId: visitData.user_account.user.userId,
                    customerId: visitData.user_account.customer.customerId,
                    agentId: currentVisit.agentId,
                    propertyConfigId: visitData.user_account.propertyConfig.propertyConfigId,
                    projectId: visitData.user_account.project.projectId,
                    visitSchedule: null,
                    visited: !currentVisit.visited,
                    visitedDateTime: currentVisit.visitedDateTime
                        ? [...currentVisit.visitedDateTime, currentVisit.visitSchedule]
                        : [currentVisit.visitSchedule],
                };

                await updateVisit(updatedVisitData);
                toast.success(`Visit marked as ${!visitData.visited ? "Visited" : "Not Visited"} successfully!`);
                fetchCustomerUsers();
                fetchScheduledVisitsCount();
            }
        } catch (error) {
            
            let errorMsg = "Failed to mark visit as visited.";
            if (error?.response?.data?.message) {
                errorMsg += ` ${error.response.data.message}`;
            } else if (error?.message) {
                errorMsg += ` ${error.message}`;
            }
            // Show the full error.request and error.response in the console for debugging
            if (error?.response.data.request) {
                console.error("Error request object:", error.request);
            }
            
            toast.error(errorMsg);
            console.error("Error marking visit as visited:", error);
        } finally {
            setIsLoading(false);
            // fetchCustomerUsers();
            // fetchScheduledVisitsCount();
        }
    };

    const handleCreateUserClick = (user) => {

        setSelectedUser(user.user_account.user);

        setSelectedProjectId(user.project_id || '');

        setCreateCustomerModalOpen(true); // Open the modal

        setCreateUser({
            firstName: user.user_account.user.firstName || '',
            lastName: user.user_account.user.lastName || '',
            mobileNoWa: user.user_account.user.mobileNoWa || '',
            mobileNoCalling: user.user_account.user.mobileNoCalling || '',
            emailId: user.user_account.user.emailId || '',
            address: {
                buildingNo: user.user_account.user.address?.buildingNo || '',
                streetName1: user.user_account.user.address?.streetName1 || '',
                streetName2: user.user_account.user.address?.streetName2 || '',
                city: user.user_account.user.address?.city || '',
                district: user.user_account.user.address?.district || '',
                pinCode: user.user_account.user.address?.pinCode || '',
                state: user.user_account.user.address?.state || '',
                country: user.user_account.user.address?.country || ''
            },
            gender: user.user_account.user.gender || 'MALE',
            title: user.user_account.user.title || 'MR',
            dob: user.user_account.user.dob || new Date().toISOString().split("T")[0],
            isSecondaryUser: false,
            occupation: user.user_account.user.occupation || '',
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCreateUser((prev) => {
            if (name.includes("address.")) {
                const addressField = name.split(".")[1];
                return {
                    ...prev,
                    address: {
                        ...prev.address,
                        [addressField]: value,
                    },
                };
            } else {
                return { ...prev, [name]: value };
            }
        });
    };

    // Determine user role
    // Persona discrimination: both PRESALES and SALES share DEVELOPER_SIDE persona,
    // distinguish by their permission bundle.
    const isPresale = !isDeveloperAdmin() && can(PERMISSIONS.LEAD_CREATE) && !can(PERMISSIONS.SALE_CREATE);
    const isSales = !isDeveloperAdmin() && can(PERMISSIONS.SALE_CREATE) && !can(PERMISSIONS.LEAD_CREATE);

    // Tab data: if PRESALE, omit "Hot Leads"; if SALES, show only "Hot Leads"
    const tabData = isPresale
        ? [
            { value: "cold", label: "Cold Leads" },
            { value: "lukeWarm", label: "Luke Warm Leads" },
            { value: "warm", label: "Warm Leads" },
            { value: "customers", label: "Customers" },
        ]
        : isSales
        ? [
            { value: "hot", label: "Hot Leads" },
        ]
        : [
            { value: "cold", label: "Cold Leads" },
            { value: "lukeWarm", label: "Luke Warm Leads" },
            { value: "warm", label: "Warm Leads" },
            { value: "hot", label: "Hot Leads" },
            { value: "customers", label: "Customers" },
        ];

    const processFilteredUsers = (leads, tab) => {
        if (!leads) return [];

        let result;
        switch (tab) {
            case "cold":
                // If SALES, don't show cold leads
                result = isSales ? [] : (leads.coldLeads || []);
                break;
            case "lukeWarm":
                // If SALES, don't show luke warm leads
                result = isSales ? [] : (leads.lukeWarmLeads || []);
                break;
            case "warm":
                // If SALES, don't show warm leads
                result = isSales ? [] : (leads.warmLeads || []);
                break;
            case "hot":
                // If PRESALES, do not show hot leads; if SALES, show only hot leads
                result = isPresale ? [] : (leads.hotLeads || []);
                break;
            case "customers":
                // If SALES, don't show customers
                result = isSales ? [] : (leads.customers || []);
                break;
            default:
                result = [];
        }
        
        // Ensure we always return an array
        return Array.isArray(result) ? result : [];
    };

    useEffect(() => {
        const filtered = processFilteredUsers(allLeads, activeTab);
        setFilteredUsers(Array.isArray(filtered) ? filtered : []);
    }, [activeTab, allLeads]);

    // Handle zoom changes and grid resizing
    useEffect(() => {
        const handleZoomChange = () => {
            if (gridApi.current) {
                setTimeout(() => {
                    gridApi.current.sizeColumnsToFit();
                }, 100);
            }
        };

        // Listen for zoom changes
        window.addEventListener('resize', handleZoomChange);
        
        // Check for zoom changes using devicePixelRatio
        let currentZoom = window.devicePixelRatio;
        const zoomCheckInterval = setInterval(() => {
            if (window.devicePixelRatio !== currentZoom) {
                currentZoom = window.devicePixelRatio;
                handleZoomChange();
            }
        }, 500);

        return () => {
            window.removeEventListener('resize', handleZoomChange);
            clearInterval(zoomCheckInterval);
        };
    }, []);

    const handleViewClick = (user) => {
        setSearchQuery("");

        setSelectedUser(user);

        setLeadDetailsDrawerOpen(true);
    };

    const handleUploadOptionChange = (option) => {
        setSelectedUploadOption(option);
        setUploadLeadsDropdownOpen(false);

        if (option === "manual") {
            handleManualUploadModal();
        } else if (option === "csv") {
            handleCsvUploadModalOpen();
        }
    };

    const coldLeadColumns = [
        {
            headerName: "Name",
            field: "name",
            valueGetter: (params) => {
                const firstName = params.data?.user_account?.user?.firstName || "";
                const lastName = params.data?.user_account?.user?.lastName || "";
                return `${firstName} ${lastName}`.trim();
            },
            minWidth: 120,
            maxWidth: 200,
            flex: 1,
        },
        { headerName: "Mobile No (Call)", field: "user_account.user.mobileNoCalling", minWidth: 130, maxWidth: 180, flex: 1 },
        { headerName: "Project", field: "user_account.project.projectName", minWidth: 120, maxWidth: 180, flex: 1 },
        {
            headerName: "Referred By",
            field: "user_account.referrerUserId",
            minWidth: 160,
            maxWidth: 240,
            flex: 1,
            cellRenderer: ReferralTagRenderer,
        },
        //{ headerName: "Mobile No (WhatsApp)", field: "user_account.user.mobileNoWa", minWidth: 130, maxWidth: 180, flex: 1 },
        // {
        //     headerName: "Lead Status",
        //     field: "user_account.leadStatus",
        //     minWidth: 150,
        //     maxWidth: 200,
        //     flex: 1,
        //     cellRenderer: (params) => {
        //         return React.createElement(LeadStatusRenderer, {
        //             value: params.value,
        //             data: params.data,
        //             onStatusChange: fetchCustomerUsers,
        //             onRowUpdate: handleRowUpdate
        //         });
        //     }
        // },
        { headerName: "Email", field: "user_account.user.emailId", minWidth: 150, maxWidth: 250, flex: 1 },
        {
            headerName: "Comments",
            field: "user_account.comment",
            minWidth: 150,
            maxWidth: 300,
            flex: 2,
            valueGetter: (params) => {
                const commentDict = params.data?.user_account?.comment;
                if (!commentDict || Object.keys(commentDict).length === 0) {
                    return "";
                }
                const latestKey = Object.keys(commentDict).sort((a, b) => parseInt(b) - parseInt(a))[0];
                const latestComment = commentDict[latestKey];
                return latestComment?.description || "";
            },
        },
        { headerName: "Last WhatsApp Message", field: "user_account.lastMessageSentTimestamp", minWidth: 150, maxWidth: 200, flex: 1 },
        { headerName: "Conversation Status", field: "user_account.lastReplyTimeStamp", minWidth: 150, maxWidth: 200, flex: 1 },
        {
            headerName: "Status",
            field: "user_account.status",
            minWidth: 80,
            maxWidth: 120,
            flex: 0.5,
            cellRenderer: (params) => (
                <div style={{
                    width: "60%",
                    height: '100%',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <div className={`px-3 py-1 rounded-full text-xs font-semibold w-fit 
                        ${params.value === "CLOSED"
                            ? "bg-red-500/20 text-red-700 "
                            : params.value === "OPEN"
                                ? "bg-emerald-500/20 text-emerald-700"
                                : "bg-slate-500/20 text-slate-700"
                        }`}
                    >
                        {params.value}
                    </div>
                </div>
            ),
        },
        {
            headerName: "Actions",
            field: "actions",
            minWidth: 200,
            maxWidth: 300,
            flex: 1.5,
            cellStyle: {
                justifyContent: "flex-start"
            },
            cellRenderer: (params) => {
                const hasConfig = params.data?.user_account?.propertyConfig?.propertyConfigId;
                return (
                    <div className="flex items-center space-x-2 h-full">
                        <Button size="sm" variant="outline" color="black" onClick={() => handleViewClick(params.data)} className="p-2">
                            <Eye size={17.5} />
                        </Button>
                        {params.data?.user_account?.user?.isAccountCreated ? (
                              <EditButton onClick={() => handleEditClick(params.data)} />
                          ) : (
                              <EditButton onClick={() => handlePreAccountEditClick(params.data)} />
                          )}

                        <Tooltip placement="right">
                            <Tooltip.Trigger>
                                <Button size="sm" variant="outline" color="black" onClick={() => handleScheduleVisitClick(params.data)} className="p-2">
                                    <CalendarPlus size={17.5} />
                                </Button>

                            </Tooltip.Trigger>
                            <Tooltip.Content className="bg-slate-800 text-white font-normal text-sm">
                                Schedule a Visit
                                <Tooltip.Arrow />
                            </Tooltip.Content>
                        </Tooltip>
                        {!hasConfig && (  //Conditionally Render
                            <Tooltip placement="right">
                                <Tooltip.Trigger>
                                    <Button size="sm" variant="outline" color="black" onClick={() => {
                                        setSelectedUser(params.data);
                                        setAssignConfigModalOpen(true);
                                    }} className="p-2">
                                        <HousePlus size={17.5} />
                                    </Button>

                                </Tooltip.Trigger>
                                <Tooltip.Content className="bg-slate-800 text-white font-normal text-sm">
                                    Assign a Config
                                    <Tooltip.Arrow />
                                </Tooltip.Content>
                            </Tooltip>
                        )}

                    </div>
                );
            },
        },
    ];
    const [selectedAgentId, setSelectedAgentId] = useState(null);
    const [agentId, setAgentId] = useState(null);
    const handleRescheduleClick = (visit, agentId) => {
        setSelectedVisit(visit);
        setSelectedAgentId(agentId);
        setAgentId(agentId)
        setOpenRescheduleDialog(true);
    };
    const handleReschedule = async (formData) => {
        try {
           
            const selectedConfig = configurations.find(
                (config) =>
                    config.propertyConfigId === parseInt(formData.propertyConfig)
            );
    
            const visitSchedule = new Date(
                `${formData.preferredDate}T${formData.preferredTime}:00`
            )
                .toISOString()
                .slice(0, -1);
    
            const buildingId = formData.buildingId || null;
           
            let visitData;
    
            if (!!selectedVisit) {
                //PUT REQUEST
                visitData = {
                    userId: selectedVisit?.user_account?.user?.userId || null,
                    customerId: selectedVisit?.user_account?.customer?.customerId || null,
                    agentId: formData.agentId || null,
                    propertyConfigId: formData.propertyConfig,
                    buildingId: buildingId,
    
                    visitSchedule,
                    visited: formData?.visited || false,
                    visitedDateTime: formData?.visitedDateTime || [],
                };
            }
            else {
                // POST REQUEST
                visitData = {
                    userId: selectedVisit?.user?.userId || null,
                    customerId:
                        selectedVisit?.user_account?.customer?.customerId || null,
                    agentId: formData.agentId || null,
                    propertyConfigId: formData.propertyConfig,
                    buildingId: buildingId,
                    visitSchedule: visitSchedule,
                    visited: false,
                    visitedDateTime: [],
                };
            }
    
            let isPutRequest = !!selectedVisit;
    
    
            if (isPutRequest) {
    
                isPutRequest =
                    selectedVisit?.user_account?.propertyConfig?.propertyConfigId ===
                    parseInt(formData.propertyConfig);
    
                if (!isPutRequest) {
                    console.log(
                        "Property config or building ID changed. Treating as new visit."
                    );
                }
            }
    
            if (isPutRequest) {
    
                const existingVisitedDateTime = formData?.visitedDateTime || [];
    
    
                if (!existingVisitedDateTime.includes(visitSchedule)) {
                    visitData.visitedDateTime = [...existingVisitedDateTime, visitSchedule];
                } else {
                    visitData.visitedDateTime = existingVisitedDateTime;
                    
                }
            }
            else {
                visitData.visitedDateTime = [];
            }
    
            try {
                    if (isPutRequest) {
                        
                        try {
    
                            await updateVisit(visitData);
                            toast.success("Visit rescheduled successfully!");
                        } catch (updateError) {
    
    
                            console.warn("Update visit failed. Attempting to schedule a new visit...", updateError);
                            try {
    
                                await scheduleVisit(visitData);
                                toast.success("New visit scheduled successfully!");
                            } catch (scheduleError) {
    
                                console.error("Both update and schedule failed:", scheduleError);
                                toast.error("Failed to reschedule or schedule a new visit.");
                            }
                        }
                    }
                    else {
                         try {
                    await scheduleVisit(visitData);
                    toast.success("New Visit scheduled successfully!");
                } catch (error) {
                    if (error.response && error.response.status === 409) {
                     
                        try {
                            await updateVisit(visitData);
                            toast.success("Visit rescheduled successfully (handling config relation conflict)!");
                        } catch (updateError) {
                            console.error("Failed to update visit:", updateError);
                            toast.error("Failed to reschedule visit, and updating also failed.");
                        }
                    }
                    else {
                       console.error("An error occurred:", error);
                        toast.error("Failed to schedule the visit.");
                    }
                }
                }
    
                setOpenRescheduleDialog(false);
                setSelectedVisit(null);
                fetchCustomerUsers();
                fetchScheduledVisitsCount();
            } catch (error) {
                console.error("Error scheduling/rescheduling:", error);
                console.error("Error handling request:", error);
            }
        } catch (error) {
            console.error("Error preparing reschedule data:", error);
        }
    };

    const allColumns = [
        {
            headerName: "Name",
            field: "name",
            valueGetter: (params) => {
                const firstName = params.data?.user_account?.user?.firstName || "";
                const lastName = params.data?.user_account?.user?.lastName || "";
                return `${firstName} ${lastName}`.trim();
            },
            minWidth: 120,
            maxWidth: 200,
            flex: 1,
        },
        { headerName: "Project", field: "user_account.project.projectName", minWidth: 120, maxWidth: 180, flex: 1 },
        { headerName: "Mobile No (WhatsApp)", field: "user_account.user.mobileNoWa", minWidth: 130, maxWidth: 180, flex: 1 },
        {
            headerName: "Config",
            field: "user_account.propertyConfig.configName",
            sortable: true,
            filter: true,
            minWidth: 100,
            maxWidth: 150,
            flex: 1,
        },
        {
            headerName: "Lead Status",
            field: "user_account.leadStatus",
            minWidth: 150,
            maxWidth: 200,
            flex: 1,
            cellRenderer: (params) => {
                return React.createElement(LeadStatusRenderer, {
                    value: params.value,
                    data: params.data,
                    onStatusChange: fetchCustomerUsers,
                    onRowUpdate: handleRowUpdate
                });
            }
        },
        // {
        //     headerName: "Comments",
        //     field: "user_account.comment",
        //     minWidth: 150,
        //     flex: 1,
        //     valueGetter: (params) => {
        //         const commentDict = params.data?.user_account?.comment;
        //         if (!commentDict || Object.keys(commentDict).length === 0) {
        //             return "";
        //         }
        //         const latestKey = Object.keys(commentDict).sort((a, b) => parseInt(b) - parseInt(a))[0];
        //         const latestComment = commentDict[latestKey];
        //         return latestComment?.description || "";
        //     },
        // },
        {
            headerName: "Status",
            field: "user_account.status",
            minWidth: 80,
            maxWidth: 120,
            flex: 0.5,
            cellRenderer: (params) => (
                <div style={{
                    width: "60%",
                    height: '100%',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <div className={`px-3 py-1 rounded-full text-xs font-semibold w-fit 
                        ${params.value === "CLOSED"
                            ? "bg-red-500/20 text-red-700 "
                            : params.value === "OPEN"
                                ? "bg-emerald-500/20 text-emerald-700"
                                : "bg-slate-500/20 text-slate-700"
                        }`}
                    >
                        {params.value}
                    </div>
                </div>
            ),
        },
        {
            headerName: "Actions",
            minWidth: 200,
            maxWidth: 300,
            flex: 1.5,
            cellClassRules: {
                "justify-center": () => true,
            },
            cellRenderer: (params) => {
                return (
                    <div className="flex items-center space-x-2 h-full">
                        <>
                            <Button size="sm" variant="outline" color="black" onClick={() => handleViewClick(params.data)} className="p-2">
                                <Eye size={17.5} />
                            </Button>

                            {params.data?.user_account?.user?.isAccountCreated ? (
                                  <EditButton onClick={() => handleEditClick(params.data)} />
                              ) : (
                                  <EditButton onClick={() => handlePreAccountEditClick(params.data)} />
                              )}
                            <Tooltip placement="right">
                                <Tooltip.Trigger>
                                    <Button size="sm" variant="outline" color="black" onClick={() => handleScheduleVisitClick(params.data)} className="p-2">
                                        <CalendarPlus size={17.5} />
                                    </Button>

                                </Tooltip.Trigger>
                                <Tooltip.Content className="bg-slate-800 text-white font-normal text-sm">
                                    Schedule a Visit
                                    <Tooltip.Arrow />
                                </Tooltip.Content>
                            </Tooltip>
                        </>

                    </div>
                );
            },
        },
    ];

    const onGridReady = (params) => {
        gridApi.current = params.api;
        
        // Initial column sizing
        params.api.sizeColumnsToFit();
        
        // Handle window resize and zoom changes
        const handleResize = () => {
            setTimeout(() => {
                params.api.sizeColumnsToFit();
            }, 100);
        };
        
        window.addEventListener('resize', handleResize);
        
        // Handle zoom changes (zoom events)
        let currentZoom = window.devicePixelRatio;
        const checkZoom = () => {
            if (window.devicePixelRatio !== currentZoom) {
                currentZoom = window.devicePixelRatio;
                handleResize();
            }
        };
        
        // Check for zoom changes periodically
        const zoomCheckInterval = setInterval(checkZoom, 500);
        
        // Cleanup function
        params.api.addEventListener('destroy', () => {
            window.removeEventListener('resize', handleResize);
            clearInterval(zoomCheckInterval);
        });
    };

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true,
        flex: 1,
        minWidth: 80,
        maxWidth: undefined,
        suppressMovable: false,
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
        autoSize: true,
        suppressSizeToFit: false,
        suppressAutoSize: false,
    };

    const getColumnDefs = () => {
        console.log('Getting column definitions for tab:', activeTab);
        if (activeTab === "cold") {
            console.log('Using coldLeadColumns:', coldLeadColumns);
            return coldLeadColumns;
        }
        if (activeTab === "lukeWarm") {
            const lukeWarmColumns = [
                ...allColumns.slice(0, allColumns.length - 1), // Exclude the original 'Actions' column
                { headerName: "Last WhatsApp Message", field: "user_account.lastMessageSentTimestamp", minWidth: 150, maxWidth: 200, flex: 1 },
                { headerName: "Conversation Status", field: "user_account.lastReplyTimeStamp", minWidth: 120, maxWidth: 180, flex: 1 },
                allColumns[allColumns.length - 1] // Add the 'Actions' column back
            ];
            return lukeWarmColumns;
        }
        if (activeTab === "warm") {

            return [
                ...allColumns.slice(0, allColumns.length - 1),
                { headerName: "Last WhatsApp Message", field: "user_account.lastMessageSentTimestamp", minWidth: 150, maxWidth: 200, flex: 1 },
                { headerName: "Conversation Status", field: "user_account.lastReplyTimeStamp", minWidth: 120, maxWidth: 180, flex: 1 },
                {
                    headerName: "Visit Schedule",
                    field: "user_account.user.userId", // Can still be used for sorting/filtering
                    valueGetter: (params) => {
                        const userId = params.data?.user_account?.user?.userId;
                        const visitData = userVisitDateTime[userId];
                        const visitSchedule = visitData?.visitSchedule;

                        if (!visitSchedule) return '-';

                        const date = new Date(visitSchedule);
                        const formattedDate = date.toLocaleDateString();
                        const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                        return `${formattedDate} at ${formattedTime}`;
                    },
                    minWidth: 150,
                    maxWidth: 200,
                    flex: 1,
                },

                {
                    headerName: "Visit Status",
                    field: "user_account.user.userId",
                    cellRenderer: (params) => {
                        const userId = params.data?.user_account?.user?.userId;
                        const visitData = userVisitDateTime[userId] || {};

                        return (
                            <div className="flex items-center justify-center h-full">
                                <VisitStatusCellRenderer
                                    data={params.data}
                                    visitData={visitData}
                                    handleMarkAsVisited={handleMarkAsVisited}
                                    globalLoading={isLoading}
                                />
                            </div>
                        );
                    },
                    minWidth: 120,
                    maxWidth: 150,
                    flex: 0.8
                },
                {
                    headerName: "Account ",
                    field: "user_account",
                    cellRenderer: (params) => {
                      const isCreated = params.data?.user_account?.user?.isAccountCreated;
                    
                      return isCreated ? (
                        <span className="ml-2 inline-block px-3 py-1 text-sm font-semibold text-blue-700 bg-blue-100 rounded-md">
                          Created
                        </span>
                      ) : (
                        <span className="ml-2 inline-block px-3 py-1 text-sm font-semibold text-yellow-700 bg-yellow-100 rounded-md">
                          Not Created
                        </span>
                      );
                    },
                    minWidth: 100,
                    maxWidth: 150,
                    flex: 0.8,
                  },

                {
                    headerName: "Actions",
                    minWidth: 250,
                    maxWidth: 350,
                    flex: 1.5,
                    cellClassRules: {
                        "justify-center": () => true,
                    },
                    cellRenderer: (params) => {

                        return (
                            <div className="flex items-center space-x-2 h-full">

                                <>
                                    <Button size="sm" variant="outline" color="black" onClick={() => handleViewClick(params.data)} className="p-2">
                                        <Eye size={17.5} />
                                    </Button>
                                    {params.data?.user_account?.user?.isAccountCreated ? (
                                      <EditButton onClick={() => handleEditClick(params.data)} />
                                  ) : (
                                      <EditButton onClick={() => handlePreAccountEditClick(params.data)} />
                                  )}


                                    <Button
                                        size="sm"
                                        variant="outline"
                                        onClick={() => {
                                            handleRescheduleClick(params.data, agentId)
                                        }}
                                        color="black"


                                    ><LucideCalendarCog size={17.5} /></Button>
                                    {!params.data?.user_account?.user?.isAccountCreated && (
                                        <Tooltip placement="right">
                                        <Tooltip.Trigger>
                                           
                                                <Button
                                                    size="sm"
                                                    variant="outline"
                                                    color="black"
                                                    onClick={() => handleCreateUserClick(params.data)}
                                                    className="p-2"
                                                >
                                                    <UserRoundPlus size={17.5} />
                                                </Button>
                                            
                                        </Tooltip.Trigger>
                                        <Tooltip.Content className="bg-slate-800 text-white font-normal text-sm">
                                         Create User Login Account
                                            <Tooltip.Arrow />
                                        </Tooltip.Content>
                                    </Tooltip>
                                    )}

                                </>

                            </div>
                        );
                    },
                },
            ];
        }
        if (activeTab === "hot") {
            
            return [
                ...allColumns.slice(0, allColumns.length - 1), // Exclude the original 'Actions' column
                { headerName: "Last WhatsApp Message", field: "user_account.lastMessageSentTimestamp", minWidth: 150, maxWidth: 200, flex: 1 },
                { headerName: "Conversation Status", field: "user_account.lastReplyTimeStamp", minWidth: 120, maxWidth: 180, flex: 1 },
                {
                    headerName: "Visit Schedule",
                    field: "user_account.user.userId", // Can still be used for sorting/filtering
                    valueGetter: (params) => {
                        const userId = params.data?.user_account?.user?.userId;
                        const visitData = userVisitDateTime[userId];
                        const visitSchedule = visitData?.visitSchedule;

                        if (!visitSchedule) return '-';

                        const date = new Date(visitSchedule);
                        const formattedDate = date.toLocaleDateString();
                        const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                        return `${formattedDate} at ${formattedTime}`;
                    },
                    minWidth: 150,
                    maxWidth: 200,
                    flex: 1,
                },

                {
                    headerName: "Visit Status",
                    field: "user_account.user.userId", // optional, only needed if using it elsewhere
                    valueGetter: (params) => {
                        const userId = params.data?.user_account?.user?.userId;
                        const visitData = userVisitDateTime[userId] || {};
                        return visitData?.visited ? "Visited" : "Not Visited";

                    },
                    cellRenderer: (params) => {
                        const userId = params.data?.user_account?.user?.userId;
                        const visitData = userVisitDateTime[userId] || {};
                        const visited = visitData?.visited;

                        if (visited !== true) {
                            return (
                                <div className="flex items-center justify-center h-full">
                                    <VisitStatusCellRenderer
                                        data={params.data}
                                        visitData={visitData}
                                        handleMarkAsVisited={handleMarkAsVisited}
                                        globalLoading={isLoading}
                                    />
                                </div>
                            );
                        } else {
                            return (
                                <div className="flex items-center" style={{ height: '100%' }}>
                                    <div className="w-fit px-2 py-1 rounded-md text-sm font-medium bg-emerald-500/30 text-emerald-700 hover:bg-emerald-500/40 flex items-center justify-center">
                                        Visited
                                    </div>
                                </div>
                            );
                        }
                    },

                    filter: true,
                    minWidth: 120,
                    maxWidth: 150,
                    flex: 0.8,
                },
                {
                    headerName: "Account ",
                    field: "user_account",
                    cellRenderer: (params) => {
                      const isCreated = params.data?.user_account?.user?.isAccountCreated;
                    
                      return isCreated ? (
                        <span className="ml-2 inline-block px-3 py-1 text-sm font-semibold text-blue-700 bg-blue-100 rounded-md">
                          Created
                        </span>
                      ) : (
                        <span className="ml-2 inline-block px-3 py-1 text-sm font-semibold text-yellow-700 bg-yellow-100 rounded-md">
                          Not Created
                        </span>
                      );
                    },
                    minWidth: 100,
                    maxWidth: 150,
                    flex: 0.8,
                  }
                  ,
                  

                {
                    headerName: "Actions",
                    minWidth: 250,
                    maxWidth: 350,
                    flex: 1.5,
                    cellClassRules: {
                        "justify-center": () => true,
                    },
                    cellRenderer: (params) => {
                        const userId = params.data?.user_account?.user?.userId;
                        const visitData = userVisitDateTime[userId] || {};
                        const agentId = visitData.agentId; // Get agentId
                        return (
                            <div className="flex items-center space-x-2 h-full">

                                <>
                                    <Button size="sm" variant="outline" color="black" onClick={() => handleViewClick(params.data)} className="p-2">
                                        <Eye size={17.5} />
                                    </Button>
                                    {params.data?.user_account?.user?.isAccountCreated ? (
                                      <EditButton onClick={() => handleEditClick(params.data)} />
                                  ) : (
                                      <EditButton onClick={() => handlePreAccountEditClick(params.data)} />
                                  )}


                                    <Button
                                        size="sm"
                                        variant="outline"
                                        onClick={() => {
                                            handleRescheduleClick(params.data, agentId)
                                        }}
                                        color="black"


                                    ><LucideCalendarCog size={17.5} /></Button>
                                    {!params.data?.user_account?.user?.isAccountCreated && (
                                        <Tooltip placement="right">
                                        <Tooltip.Trigger>
                                           
                                                <Button
                                                    size="sm"
                                                    variant="outline"
                                                    color="black"
                                                    onClick={() => handleCreateUserClick(params.data)}
                                                    className="p-2"
                                                >
                                                    <UserRoundPlus size={17.5} />
                                                </Button>
                                            
                                        </Tooltip.Trigger>
                                        <Tooltip.Content className="bg-slate-800 text-white font-normal text-sm">
                                         Create User Login Account
                                            <Tooltip.Arrow />
                                        </Tooltip.Content>
                                    </Tooltip>
                                    )}

                                </>

                            </div>
                        );
                    },
                },
            ];
        }
        return allColumns;
    };

    const toggleColumnVisibility = (columnField) => {
        setVisibleColumns(prev => ({
            ...prev,
            [columnField]: !prev[columnField]
        }));
    };

    // Adapter: convert AG-Grid columnDefs into the format DataTable expects.
    // We keep the AG-Grid column definitions verbatim (so cellRenderer / valueGetter
    // / field still work) and translate them lazily. The hide flag from
    // visibleColumns is honored by filtering the list before rendering.
    const getDotPath = (obj, path) =>
        String(path || "").split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
    const agColsToDtCols = (agCols, hidden = {}) => {
        return (agCols || [])
            .filter((c) => c && !hidden[c.field])
            .map((col, idx) => {
                const key = col.field || col.headerName || `col-${idx}`;
                const width = col.maxWidth || col.minWidth || col.width || 150;
                return {
                    key,
                    header: col.headerName || "",
                    width: Number(width),
                    render: (row) => {
                        // Build a minimal `params` object so existing AG-Grid
                        // cellRenderers continue to work without changes.
                        const params = { data: row };
                        if (typeof col.valueGetter === "function") {
                            params.value = col.valueGetter({ data: row });
                        } else if (col.field) {
                            params.value = getDotPath(row, col.field);
                        }
                        if (typeof col.cellRenderer === "function") {
                            const out = col.cellRenderer(params);
                            return out == null ? <span className="text-slate-400">—</span> : out;
                        }
                        const v = params.value;
                        return v == null || v === "" ? (
                            <span className="text-slate-400">—</span>
                        ) : (
                            <span className="text-sm text-slate-700 truncate block" title={String(v)}>
                                {String(v)}
                            </span>
                        );
                    },
                };
            });
    };

    const getAllAvailableColumns = () => {
        const columns = getColumnDefs();
        return columns.map(col => ({
            field: col.field,
            headerName: col.headerName
        }));
    };

    const handleCreateUserSubmit = async () => {
        try {
            setIsCreatingUser(true);

            const payload = {
                ...createUser,
            };
         
            if (!selectedProjectId) {
                toast.error("Please select a project.");
                return;
            }
            const userId = selectedUser.userId;


            const response = await axiosInstance.put(`/users?userId=${userId}&isAccountCreation=true`, payload);


            toast.success("User created successfully!");
            setCreateCustomerModalOpen(false); // Close the modal
            fetchCustomerUsers(); // Refresh user list
            // Reset the form
            setCreateUser({
                firstName: "",
                lastName: "",
                mobileNoWa: "",
                mobileNoCalling: "",
                emailId: "",
                address: {
                    buildingNo: "",
                    streetName1: "",
                    streetName2: "",
                    city: "",
                    district: "",
                    pinCode: "",
                    state: "",
                    country: "",
                },
                gender: "MALE",
                title: "MR",
                dob: new Date().toISOString().split("T")[0],
                occupation: "",
            });

        } catch (error) {
            console.error("Error creating user:", error);
            toast.error("Failed to create user.");
        }
        finally {
            setIsCreatingUser(false); // Stop loading
        }
    };

    const leadTypes = isPresale
        ? [
            { id: 'cold', label: 'Cold Leads' },
            { id: 'lukeWarm', label: 'Luke Warm Leads' },
            { id: 'warm', label: 'Warm Leads' },
        ]
        : isSales
        ? [
            { id: 'hot', label: 'Hot Leads' },
        ]
        : [
            { id: 'cold', label: 'Cold Leads' },
            { id: 'lukeWarm', label: 'Luke Warm Leads' },
            { id: 'warm', label: 'Warm Leads' },
            { id: 'hot', label: 'Hot Leads' },
        ];

    // Per-temperature lead counts powering the KPI tiles.
    const coldCount = (allLeads?.coldLeads || []).length;
    const lukeWarmCount = (allLeads?.lukeWarmLeads || []).length;
    const warmCount = (allLeads?.warmLeads || []).length;
    const hotCount = (allLeads?.hotLeads || []).length;

    // Tooltip + style metadata per lead temperature — drives the pill nav.
    const tempMeta = {
        cold: {
            tooltip: "Leads that have had no contact or minimal initial contact. These require initial engagement.",
            count: coldCount,
            dot: "bg-sky-500",
        },
        lukeWarm: {
            tooltip: "Leads with config interest captured. They may have responded to initial contact or visited your website.",
            count: lukeWarmCount,
            dot: "bg-amber-500",
        },
        warm: {
            tooltip: "Leads who have scheduled a site visit, indicating stronger interest.",
            count: warmCount,
            dot: "bg-orange-500",
        },
        hot: {
            tooltip: "Leads who have scheduled multiple site visits and need personalized support to finalize.",
            count: hotCount,
            dot: "bg-rose-500",
        },
    };

    return (
        <div className="flex flex-col gap-6">
            {/* Hero band */}
            <div className="rounded-2xl shadow-sm bg-gradient-to-r from-slate-800 via-slate-700 to-slate-600 p-5 lg:p-6 text-white">
                <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                    <div>
                        <p className="text-xs uppercase tracking-wider text-slate-300 flex items-center gap-1.5">
                            <Users size={12} />
                            Sales
                        </p>
                        <h1 className="text-xl sm:text-2xl font-semibold tracking-tight mt-1">Leads</h1>
                        <p className="text-xs text-slate-300 mt-1">
                            Filter by lead temperature, customize columns, and act on each lead from one place
                        </p>
                    </div>
                    <div className="relative self-start lg:self-auto">
                        <DisabledWithTooltip feature={SUB_FEATURES.LEADS_MUTATION} wrap="div">
                            <PrimaryButton onClick={() => setUploadLeadsDropdownOpen(!uploadLeadsDropdownOpen)}>
                                <Upload className="mr-2" size={16} />
                                Upload leads
                            </PrimaryButton>
                        </DisabledWithTooltip>
                        {uploadLeadsDropdownOpen && (
                            <div className="absolute right-0 mt-2 w-52 bg-white border border-slate-200 rounded-xl shadow-lg z-10 overflow-hidden">
                                <button
                                    type="button"
                                    className="block w-full px-4 py-2.5 text-sm text-slate-700 hover:bg-flamingo-50 hover:text-flamingo-700 text-left transition-colors border-b border-slate-100"
                                    onClick={() => handleUploadOptionChange("csv")}
                                >
                                    Upload CSV
                                </button>
                                <button
                                    type="button"
                                    className="block w-full px-4 py-2.5 text-sm text-slate-700 hover:bg-flamingo-50 hover:text-flamingo-700 text-left transition-colors"
                                    onClick={() => handleUploadOptionChange("manual")}
                                >
                                    Manual upload
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* KPI tiles — per-temperature counts, scannable at a glance. */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {!isSales && !isPresale && (
                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-sky-50 text-sky-600 flex items-center justify-center shrink-0">
                            <Users size={20} />
                        </div>
                        <div>
                            <p className="text-xs uppercase tracking-wide text-slate-500 font-medium">Cold</p>
                            <p className="text-2xl font-bold text-slate-900 tabular-nums">{coldCount}</p>
                        </div>
                    </div>
                )}
                {!isSales && (
                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-700 flex items-center justify-center shrink-0">
                            <Users size={20} />
                        </div>
                        <div>
                            <p className="text-xs uppercase tracking-wide text-slate-500 font-medium">Luke warm</p>
                            <p className="text-2xl font-bold text-slate-900 tabular-nums">{lukeWarmCount}</p>
                        </div>
                    </div>
                )}
                {!isSales && (
                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center shrink-0">
                            <Users size={20} />
                        </div>
                        <div>
                            <p className="text-xs uppercase tracking-wide text-slate-500 font-medium">Warm</p>
                            <p className="text-2xl font-bold text-slate-900 tabular-nums">{warmCount}</p>
                        </div>
                    </div>
                )}
                {!isPresale && (
                    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 flex items-center gap-3">
                        <div className="w-10 h-10 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center shrink-0">
                            <Users size={20} />
                        </div>
                        <div>
                            <p className="text-xs uppercase tracking-wide text-slate-500 font-medium">Hot</p>
                            <p className="text-2xl font-bold text-slate-900 tabular-nums">{hotCount}</p>
                        </div>
                    </div>
                )}
            </div>

            {/* Pill tab nav — same flamingo gradient on active as the rest of the app. */}
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-1.5 inline-flex gap-1 self-start flex-wrap">
                {leadTypes.map((tab) => {
                    const isActive = activeTab === tab.id;
                    const meta = tempMeta[tab.id] || {};
                    return (
                        <Tooltip key={tab.id} placement="top">
                            <Tooltip.Trigger asChild>
                                <button
                                    type="button"
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-medium transition-colors ${
                                        isActive
                                            ? "bg-gradient-to-r from-flamingo-500 to-flamingo-600 text-white shadow-sm"
                                            : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                                    }`}
                                    aria-label={`${tab.label} - ${meta.tooltip || ""}`}
                                >
                                    <span className={`w-1.5 h-1.5 rounded-full ${
                                        isActive ? "bg-white" : meta.dot || "bg-slate-400"
                                    }`} />
                                    {tab.label}
                                    {typeof meta.count === "number" && (
                                        <span className={`tabular-nums px-1.5 py-0.5 rounded-md text-[10px] font-semibold ${
                                            isActive
                                                ? "bg-white/20 text-white"
                                                : "bg-slate-100 text-slate-600"
                                        }`}>
                                            {meta.count}
                                        </span>
                                    )}
                                    <Info size={12} className={isActive ? "text-white/70" : "text-slate-400"} />
                                </button>
                            </Tooltip.Trigger>
                            <Tooltip.Content className="bg-white text-slate-700 text-sm font-normal border border-slate-200 w-72 p-2 z-50 shadow-lg rounded-lg">
                                {meta.tooltip || ""}
                                <Tooltip.Arrow />
                            </Tooltip.Content>
                        </Tooltip>
                    );
                })}
            </div>

                {/* Content Based on Active Tab — no wrapper padding so the
                    search bar / leads count sit flush-left with the pill tab
                    strip above. */}
                <div>
                    {activeTab === "cold" || activeTab === "lukeWarm" ? (
                        <>
                            {/* Controls above the table */}
                            <div className="flex justify-between items-center gap-3 mb-3">
                                <div className="flex-1 min-w-0 max-w-md">
                                    <CustomInput
                                        type="text"
                                        placeholder="Search customers…"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="relative">
                                    <Button
                                        size="sm"
                                        variant="outline"
                                        color="black"
                                        onClick={() => setColumnVisibilityOpen(!columnVisibilityOpen)}
                                        className="flex items-center gap-2 hover:bg-gray-50 border border-gray-200 bg-transparent"
                                    >
                                        <Settings size={17.5} />
                                        <span>Customize Columns</span>
                                    </Button>
                                    {columnVisibilityOpen && (
                                        <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-200 rounded-md shadow-md z-10">
                                            <div className="p-2 border-b border-gray-200">
                                                <h3 className="text-xs font-semibold text-gray-700">Column Visibility</h3>
                                                <p className="text-xs text-gray-400 mt-0.5">Select columns to display</p>
                                            </div>
                                            <div style={{ 
                                                maxHeight: 'min(300px, 60vh)', 
                                                overflowY: 'auto', 
                                                padding: '4px',
                                                scrollbarWidth: 'thin'
                                            }}>
                                                {getAllAvailableColumns().map((column) => (
                                                    <div 
                                                        key={column.field} 
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer',
                                                            transition: 'background-color 100ms'
                                                        }}
                                                        onClick={() => toggleColumnVisibility(column.field)}
                                                        title={column.headerName}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            id={column.field}
                                                            checked={!visibleColumns[column.field]}
                                                            onChange={() => {}}
                                                            style={{
                                                                borderRadius: '4px',
                                                                borderColor: '#D1D5DB',
                                                                color: '#2563EB',
                                                                height: '12px',
                                                                width: '12px',
                                                                marginTop: '2px'
                                                            }}
                                                        />
                                                        <label 
                                                            htmlFor={column.field} 
                                                            style={{
                                                                fontSize: '14px',
                                                                color: '#374151',
                                                                cursor: 'pointer',
                                                                fontWeight: '500',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '120px',
                                                                lineHeight: '1.2'
                                                            }}
                                                        >
                                                            {column.headerName}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <div style={{ 
                                                borderTop: '1px solid #E5E7EB',
                                                padding: '4px',
                                                backgroundColor: '#F9FAFB'
                                            }}>
                                                <Button
                                                    onClick={() => setVisibleColumns({})}
                                                    style={{
                                                        width: '100%',
                                                        justifyContent: 'center',
                                                        fontSize: '12px',
                                                        padding: '4px 8px',
                                                        minHeight: '0'
                                                    }}
                                                >
                                                    Reset to Default
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <DataTable
                                columns={agColsToDtCols(getColumnDefs(), visibleColumns)}
                                data={Array.isArray(filteredUsers) ? filteredUsers : []}
                                loading={!users}
                                minWidth={1600}
                                rowKey={(r, i) => r?.user_account?.user?.userId ?? r?.customerSalesId ?? i}
                                emptyState={
                                    <div className="px-6 py-12 text-center">
                                        <p className="text-base font-semibold text-slate-900">No leads found</p>
                                        <p className="text-sm text-slate-500 mt-1">
                                            Try adjusting your filters or switch to a different lead temperature tab.
                                        </p>
                                    </div>
                                }
                            />
                        </>

                    ) : (
                        <>
                            {/* Controls above the table */}
                            <div className="flex justify-between items-center gap-3 mb-3">
                                <div className="flex-1 min-w-0 max-w-md">
                                    <CustomInput
                                        type="text"
                                        placeholder="Search customers…"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="relative">
                                    <Button
                                        size="sm"
                                        variant="outline"
                                        color="black"
                                        onClick={() => setColumnVisibilityOpen(!columnVisibilityOpen)}
                                        className="flex items-center gap-2 hover:bg-gray-50 border border-gray-200 bg-transparent"
                                    >
                                        <Settings size={17.5} />
                                        <span>Customize Columns</span>
                                    </Button>
                                    {columnVisibilityOpen && (
                                        <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-200 rounded-md shadow-md z-10">
                                            <div className="p-2 border-b border-gray-200">
                                                <h3 className="text-xs font-semibold text-gray-700">Column Visibility</h3>
                                                <p className="text-xs text-gray-400 mt-0.5">Select columns to display</p>
                                            </div>
                                            <div style={{
                                                maxHeight: 'min(300px, 60vh)',
                                                overflowY: 'auto',
                                                padding: '4px',
                                                scrollbarWidth: 'thin'
                                            }}>
                                                {getAllAvailableColumns().map((column) => (
                                                    <div 
                                                        key={column.field} 
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer',
                                                            transition: 'background-color 100ms'
                                                        }}
                                                        onClick={() => toggleColumnVisibility(column.field)}
                                                        title={column.headerName}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            id={column.field}
                                                            checked={!visibleColumns[column.field]}
                                                            onChange={() => {}}
                                                            style={{
                                                                borderRadius: '4px',
                                                                borderColor: '#D1D5DB',
                                                                color: '#2563EB',
                                                                height: '12px',
                                                                width: '12px',
                                                                marginTop: '2px'
                                                            }}
                                                        />
                                                        <label 
                                                            htmlFor={column.field} 
                                                            style={{
                                                                fontSize: '14px',
                                                                color: '#374151',
                                                                cursor: 'pointer',
                                                                fontWeight: '500',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '120px',
                                                                lineHeight: '1.2'
                                                            }}
                                                        >
                                                            {column.headerName}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <div style={{ 
                                                borderTop: '1px solid #E5E7EB',
                                                padding: '4px',
                                                backgroundColor: '#F9FAFB'
                                            }}>
                                                <Button
                                                    onClick={() => setVisibleColumns({})}
                                                    style={{
                                                        width: '100%',
                                                        justifyContent: 'center',
                                                        fontSize: '12px',
                                                        padding: '4px 8px',
                                                        minHeight: '0'
                                                    }}
                                                >
                                                    Reset to Default
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <DataTable
                                columns={agColsToDtCols(getColumnDefs(), visibleColumns)}
                                data={Array.isArray(filteredUsers) ? filteredUsers : []}
                                loading={!users}
                                minWidth={1600}
                                rowKey={(r, i) => r?.user_account?.user?.userId ?? r?.customerSalesId ?? i}
                                emptyState={
                                    <div className="px-6 py-12 text-center">
                                        <p className="text-base font-semibold text-slate-900">No leads found</p>
                                        <p className="text-sm text-slate-500 mt-1">
                                            Try adjusting your filters or switch to a different lead temperature tab.
                                        </p>
                                    </div>
                                }
                            />
                        </>
                    )}
                </div>
            {createCustomerModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="relative bg-white rounded-lg shadow-lg p-8 w-full max-w-4xl mx-4">
                        <div className="flex justify-between items-center pb-4 mb-4 border-b">
                            <h3 className="text-md font-semibold">Create User Account</h3>
                            <CloseButton onClick={() => setCreateCustomerModalOpen(false)} />
                        </div>

                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2">Select Project</label>
                            <select
                                value={selectedProjectId}
                                onChange={(e) => setSelectedProjectId(e.target.value)}
                                className="shadow appearance-none rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline pr-8"
                            >
                                <option value="">Select Project</option>
                                {projects.map((project) => (
                                    <option key={project.projectId} value={project.projectId}>
                                        {project.projectName}
                                    </option>
                                ))}
                            </select>
                            {selectedProjectId && (
                                <p className="text-sm text-gray-600 mt-2">
                                    Selected Project ID: {selectedProjectId}
                                </p>
                            )}
                        </div>

                        <CreateUser
                            formData={createUser}
                            handleInputChange={handleInputChange}
                            occupations={occupations}
                        />
                        <div className="flex justify-end mt-6">
                            <IconButton
                                onClick={handleCreateUserSubmit}
                                left
                                className={"w-32"}
                                disabled={isCreatingUser || !selectedProjectId}
                            >
                                {isCreatingUser ? <Loader2 className="animate-spin mr-2" size={16} /> : "Create"}
                            </IconButton>
                        </div>
                    </div>
                </div>
            )}
            <LeadDetailsDrawer
                open={leadDetailsDrawerOpen}
                onClose={handleLeadDetailsDrawerClose}
                user={selectedUser}
            />


            {openRescheduleDialog && (
                <RescheduleVisit
                    open={openRescheduleDialog}
                    onClose={() => setOpenRescheduleDialog(false)}
                    onSubmit={handleReschedule}
                    visit={{ ...selectedVisit, agentId: selectedAgentId }}
                    configurations={configurations}
                />
            )}
            <PreAccountEditModal
                open={isPreAccountEditModalOpen}
                onClose={() => { setIsPreAccountEditModalOpen(false); setEditedPreAccountUser(null); }}  // Close the modal
                user={editedPreAccountUser?.user_account?.user}
                onSave={handlePreAccountEditSave}
            />
            {scheduleVisitModalOpen && (
                <ScheduleVisit
                    openDialog={scheduleVisitModalOpen}
                    setOpenDialog={setScheduleVisitModalOpen}
                    flowType="scheduleVisit"
                    existingUser={selectedUser.user_account.user}
                    lead={selectedUser}
                    projects={projects}   //Pass project
                    setNewScheduleVisit={setNewScheduleVisit}
                    onVisitScheduled={() => {
                        fetchCustomerUsers(); // Refresh user list
                        fetchScheduledVisitsCount();
                        setNewScheduleVisit({ preferredDate: "", preferredTime: "" }); //Reset
                    }}

                />
            )}

            <ManualLeadUploadModal
                open={manualUploadModalOpen}
                onClose={() => setManualUploadModalOpen(false)}
                projects={projects}
                onRawLeadCreated={() => {
                    fetchCustomerUsers();
                    fetchScheduledVisitsCount();
                }}
            />

            {/* Edit User Modal */}
            {editModalOpen && selectedUser && (
                <EditUserModal
                    open={editModalOpen}
                    onClose={handleCloseEditModal}
                    user={selectedUser?.user_account?.user}
                    onSave={handleEditCustomer}
                />
            )}

            {/* Manual Upload Modal */}
            {/* {manualUploadModalOpen && (
            <ManualUploadModal
                open={manualUploadModalOpen}
                onClose={() => setManualUploadModalOpen(false)}
                newRawLead={newRawLead}
                setNewRawLead={setNewRawLead}
                onSave={handleManualUpload}
                projects={projects}
            />
        )} */}

            {/* CSV Upload Modal */}
            <CsvUploadModal
                open={csvUploadModalOpen}
                onClose={handleCsvUploadModalClose}
                selectedCsvFile={selectedCsvFile}
                onFileSelect={handleFileSelect}
                onUpload={handleCsvUpload}
                projects={projects}
            />
            <ConfigAssignmentModal
                open={assignConfigModalOpen}
                onClose={() => setAssignConfigModalOpen(false)}
                propertyConfigs={propertyConfigs}
                onAssign={(selectedConfig) => handleAssignConfig(selectedConfig)}
                configAssignmentLoading={configAssignmentLoading}
            />
        </div>
    );
}
export default LeadsDashboard;